<template>
  <!-- 我司车型/竞品产品价格 -->
  <div class="table_container">
    <div class="table-btn" style="margin: 24px 0 12px 0">
      <el-button
        v-if="$route.query.operateType !== '查看'"
        :disabled="tableData.length >= 15"
        type="primary"
        size="small"
        @click="handleAdd()"
        >添加</el-button
      >
    </div>
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
        background: '#EFEFEF',
        color: '#000',
        borderColor: '#dcdfe6'
      }"
      :cell-class-name="cellClassName"
      @cell-click="handleCellClick"
      v-loading="loading"
    >
      <!-- 序号 -->
      <el-table-column label="序号" width="50px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- 我司成交均价 -->
      <el-table-column label="我司成交均价" align="center">
        <!-- 车型 -->
        <el-table-column
          prop="mineCarModel"
          label="车型"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="editField === 'mineCarModel' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.mineCarModel"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.mineCarModel }}
            </div>
          </template>
        </el-table-column>
        <!-- 均价 (美元/台) -->
        <el-table-column
          prop="minePrice"
          label="均价 (美元/台)"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="editField === 'minePrice' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.minePrice"
              class="number_input"
              :controls="false"
              :precision="2"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.minePrice }}
            </span>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 竞品 -->
      <el-table-column label="竞品" align="center">
        <!-- 品牌 -->
        <el-table-column
          prop="competitionBrand"
          label="品牌"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'competitionBrand' && editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.competitionBrand"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.competitionBrand }}
            </div>
          </template>
        </el-table-column>
        <!-- 类别 -->
        <el-table-column
          prop="competitionType"
          label="类别"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-if="
                editField === 'competitionType' && editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.competitionType"
              placeholder="请选择"
              filterable
              clearable
              size="mini"
              automatic-dropdown
              @visible-change="visibleChange"
              @change="confirmEdit"
            >
              <el-option label="直接竞品" value="直接竞品"></el-option>
              <el-option label="潜在竞品" value="潜在竞品"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
            <div v-else>
              {{ scope.row.competitionType }}
            </div>
          </template>
        </el-table-column>
        <!-- 车型 -->
        <el-table-column
          prop="competitionCarModel"
          label="车型"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'competitionCarModel' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.competitionCarModel"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.competitionCarModel }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column
        v-if="$route.query.operateType !== '查看'"
        label="操作"
        align="center"
        width="90px"
        fixed="right"
      >
        <template slot-scope="scope">
          <!-- 删除 -->
          <el-button size="mini" type="text" @click="handleDelete(scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  addOrUpdateCompeteProductPriceApi,
  validDeleteCompeteProductPriceApi
} from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      editField: "", // 编辑单元格
      editIndex: -1 // 编辑行索引
    };
  },
  methods: {
    init(data) {
      this.tableData = data || [];
    },
    // 添加
    handleAdd() {
      this.tableData.push({
        mineCarModel: "",
        minePrice: undefined,
        competitionBrand: "",
        competitionType: "",
        competitionCarModel: ""
      });
    },
    // 删除
    async handleDelete(index) {
      if (this.tableData[index].id) {
        this.loading = true;
        try {
          const res = await validDeleteCompeteProductPriceApi({
            id: this.tableData[index].id
          });
          if (res.status == 0) {
            this.tableData.splice(index, 1);
          } else {
            this.$DonMessage.error(res.message);
          }
        } catch (error) {}
        this.loading = false;
      } else {
        this.tableData.splice(index, 1);
      }
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      if (this.$route.query.operateType === "查看") return;
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // el-select 显示隐藏选项框时触发
    visibleChange(visible) {
      if (!visible) {
        this.confirmEdit();
      }
    },
    // 保存
    async handleSave(params) {
      try {
        const submitData = {
          ...params,
          dataList: JSON.parse(JSON.stringify(this.tableData))
        };
        const res = await addOrUpdateCompeteProductPriceApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableData = res.data;
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
}
</style>
